<template>
    <div>
        <modal v-model="batchChangeParcelsModal" @hide="resetBatchChangeParcelsModal" size="lg">
            <span slot="title">{{ titleBatchChangeParcelsModal_l1 }}<br>{{ titleBatchChangeParcelsModal_l2 }}</span>
            <h3>Reajustar valor</h3>
            <div class="row">
                <div class="col-lg-3">
                    <div :class="[ $v.readjustBatchValue.parcelFrom.required && $v.readjustBatchValue.parcelFrom.minValue ? '' : 'has-error', 'form-group',  ]">
                        <label class="control-label">DA PARCELA</label>
                        <input type="number" min="1" class="form-control input-sm" v-model="readjustBatchValue.parcelFrom" />
                    </div>
                </div>
                <div class="col-lg-3">
                    <div :class="[ $v.readjustBatchValue.parcelTo.required && $v.readjustBatchValue.parcelTo.minValue ? '' : 'has-error', 'form-group',  ]">
                        <label class="control-label">ATÉ A PARCELA</label>
                        <input type="number" min="1" class="form-control input-sm" v-model="readjustBatchValue.parcelTo" />
                    </div>
                </div>
                <div class="col-lg-3">
                    <div :class="[ $v.readjustBatchValue.newValue.required && $v.readjustBatchValue.newValue.minValue ? '' : 'has-error', 'form-group',  ]">
                        <label class="control-label">NOVO VALOR</label>
                        <currency-input currency="BRL" class="form-control input-sm" v-model="readjustBatchValue.newValue" :allow-negative="false" :auto-decimal-mode="true" :distraction-free="false"/>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="form-group">
                        <br>
                        <btn type="primary" @click="batchChangeValueOrthodonticsParcels('value')" :disabled="false"><i class="fa fa-save" aria-hidden="true"></i> Alterar valores</btn>
                    </div>
                </div>
            </div>
            <hr>
            <h3>Alterar vencimentos</h3>
            <div class="row">
                <div class="col-lg-3">
                    <div :class="[ $v.readjustBatchExpiration.parcelFromExpiration.required && $v.readjustBatchExpiration.parcelFromExpiration.minValue ? '' : 'has-error', 'form-group',  ]">
                        <label class="control-label">A PARTIR DA PARCELA</label>
                        <input type="number" class="form-control input-sm" v-model="readjustBatchExpiration.parcelFromExpiration" />
                    </div>
                </div>
                <div class="col-lg-3">
                    <div :class="[ $v.readjustBatchExpiration.newExpiration.required && $v.readjustBatchExpiration.newExpiration.dateRange ? '' : 'has-error', 'form-group',  ]">
                        <label class="control-label">NOVO VENCIMENTO</label>
                        <input type="date" class="form-control input-sm" v-model="readjustBatchExpiration.newExpiration"/>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="form-group">
                        <label class="control-label">Periodicidade</label>
                        <select class="form-control" v-model="readjustBatchExpiration.selectedFrequency">
                            <option value="monthly">Mensal</option>
                            <option value="biweekly">Quinzenal</option>
                            <option value="weekly">Semanal</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="form-group">
                        <br>
                        <btn type="primary" @click="batchChangeExpirationDateOrthodonticsParcels" :disabled="false"><i class="fa fa-save" aria-hidden="true"></i> Alterar vencimento</btn>
                    </div>
                </div>
            </div>

            <div slot="footer">
                <btn @click="batchChangeParcelsModal = false">Cancelar</btn>
            </div>
        </modal>

        <modal v-model="changeParcelsModal" @hide="resetChangeParcelsModal">
            <span slot="title">{{ titleChangeParcelsModal_l1 }}<br>{{ titleChangeParcelsModal_l2 }}</span>
            <div v-for="(parcel,index) in $v.checkedParcelsChange.$each.$iter" :key="index">
                <div class="row">
                    <div class="col-lg-2">
                        <label class="control-label">CÓD.</label><br>
                        {{parcel.id.$model}}
                    </div>
                    <div class="col-lg-3">
                        <div :class="[ parcel.parcel.required && parcel.parcel.minValue ? '' : 'has-error', 'form-group',  ]">
                            <label class="control-label">PARCELA</label>
                            <input type="number" class="form-control input-sm" disabled v-model="parcel.parcel.$model" />
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div :class="[ parcel.expiration_date.required && parcel.expiration_date.dateRange ? '' : 'has-error', 'form-group',  ]">
                            <label class="control-label">VENCIMENTO</label>
                            <input type="date" class="form-control input-sm" v-model="parcel.expiration_date.$model" />
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <label class="control-label">VALOR</label>
                        <currency-input v-model="parcel.value.$model" currency="BRL" class="form-control input-sm" :allow-negative="false" :auto-decimal-mode="true" :distraction-free="false"/>
                    </div>
                </div>
            </div>

            <div slot="footer">
                <btn @click="changeParcelsModal = false">Cancelar</btn>
                <btn type="primary" @click="changeOrthodonticsParcels" :disabled="false"><i class="fa fa-save" aria-hidden="true"></i> {{ okTextChangeParcelsModal }}</btn>
            </div>
        </modal>

        <modal v-model="addParcelsModal" :title="titleAddParcelsModal" @hide="resetAddParcelsModal" size="lg">
            <div class="row">
                <div class="col-lg-2">
                    <div :class="[ $v.orthodonticsParcels.parcel_number.required && $v.orthodonticsParcels.parcel_number.minValue ? '' : 'has-error', 'form-group',  ]">
                        <label class="control-label">Parcelas</label>
                        <input type="number" step="1" class="form-control" v-model="orthodonticsParcels.parcel_number" />
                    </div>
                </div>
                <div class="col-lg-3">
                    <div :class="[ $v.orthodonticsParcels.expirationDateFirstParcel.required && $v.orthodonticsParcels.expirationDateFirstParcel.dateRange ? '' : 'has-error', 'form-group',  ]">
                        <label class="control-label">1º Vencimento</label>
                        <input type="date" class="form-control" v-model="orthodonticsParcels.expirationDateFirstParcel" />
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="form-group">
                        <label class="control-label">Periodicidade</label>
                        <select class="form-control" v-model="orthodonticsParcels.selectedFrequency">
                            <option value="monthly">Mensal</option>
                            <option value="biweekly">Quinzenal</option>
                            <option value="weekly">Semanal</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div :class="[ $v.orthodonticsParcels.monthlyPayment.required && $v.orthodonticsParcels.monthlyPayment.minValue ? '' : 'has-error', 'form-group',  ]">
                        <label class="control-label">Valor mensalidade</label>
                        <currency-input v-model="orthodonticsParcels.monthlyPayment" currency="BRL" class="form-control" :allow-negative="false" :auto-decimal-mode="true" :distraction-free="false"/>
                    </div>
                </div>
            </div>

            <div slot="footer">
                <btn @click="addParcelsModal = false">Cancelar</btn>
                <btn type="primary" @click="addOrthodonticsParcels" :disabled="false"><i class="fa fa-save" aria-hidden="true"></i> {{ okTextAddParcelsModal }}</btn>
            </div>
        </modal>

        <div class="row">
            <div class="col-md-12">
                <div class="box box-default">
                    <div class="box-header with-border">
                        <i class="fa fa-info-circle"></i>
                        <h3 class="box-title">Parcelas de tratamentos ortodonticos</h3>
                        <div class="btn-toolbar">
                            <btn type="primary" class="pull-right" @click="handleReadjustBatchModal"><i class="fa fa-cogs" aria-hidden="true"></i> Reajustar lote</btn>
                            <btn type="primary" class="pull-right" @click="handleChangeParcelsModal"><i class="fa fa-pencil" aria-hidden="true"></i> Alterar parcelas</btn>
                            <btn type="primary" class="pull-right" @click="handleAddParcelsModal"><i class="fa fa-plus" aria-hidden="true"></i> Adicionar parcelas</btn>
                        </div>
                    </div>
                    <div class="box-body">
                        <datatable-component search-placeholder-prop="Buscar..." ref="dataTables" class="mt-3"
                                             :columns-prop="columns"
                                             url-prop="/orthodontic/get/all"
                                             :tableDataSendRequestProp="{patient_id: this.orthodonticsParcels.patient_id}"
                                             default-order-prop="id">
                            <template v-slot:afterHeader>
                                <tr><td colspan="8"><input type="checkbox" v-model="checkAll" id="checkAll"> <label for="checkAll"> Selecionar tudo</label></td></tr>
                            </template>
                            <template v-slot:checkbox="data">
                                <input v-if="data.data.situation === 'PENDING'" type="checkbox" :value="data.data" v-model="checkedParcels">
                            </template>
<!--                            <template v-slot:action="data">-->
<!--                                <li class="m-1" @click="editDentalPlan(data.data)"><a href="javascript:void(0)" title="Editar"><i class="fa fa-edit" aria-hidden="true"></i> Alterar</a></li>-->
<!--                                <li class="m-1" @click="deleteDentalPlan(data.data)"><a href="javascript:void(0)" title="Excluir"><i class="fa fa-trash" aria-hidden="true"></i> Excluir</a></li>-->
<!--                            </template>-->
                        </datatable-component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import {required, minValue, requiredIf} from "vuelidate/lib/validators";
    import { CurrencyInput } from 'vue-currency-input'
    import DatatableComponent from "../../../datatable/datatable-component";

    export default {
        name: "OrthodonticsFinancial",

        components: { CurrencyInput, DatatableComponent },

        props: {
            patientProp: {type: Object},
        },

        validations: {
            orthodonticsParcels: {
                parcel_number: {required, minValue: minValue(1)},
                monthlyPayment: {required, minValue: minValue(0)},
                expirationDateFirstParcel: {
                    dateRange: date => {
                        if (date && date.length === 10) {
                            return moment(date, "YYYY-MM-DD").isBetween('1901-01-01', '2200-12-31', null, '[]')
                        } else if (date && date.length > 10) {
                            return false
                        }
                        return true
                    }, required,
                },
            },

            checkedParcelsChange: {
                $each: {
                    id: {},
                    parcel: {required, minValue: minValue(1)},
                    expiration_date: {
                        dateRange: date => {
                            if (date && date.length === 10) {
                                return moment(date, "YYYY-MM-DD").isBetween('1901-01-01', '2200-12-31', null, '[]')
                            } else if (date && date.length > 10) {
                                return false
                            }
                            return true
                        }, required,
                    },
                    value: {required, minValue: minValue(0)},
                    // payday: {
                    //     requiredIf: requiredIf( items => items.situation === 'PAID' ),
                    //     dateRange: (date, items) => {
                    //         if (date && date.length === 10 && items.situation === 'PAID') {
                    //             return moment(date, "YYYY-MM-DD").isBetween('1901-01-01', '2200-12-31', null, '[]')
                    //         } else if (date && date.length > 10) {
                    //             return false
                    //         }
                    //         return true
                    //     },
                    // },
                }
            },

            readjustBatchExpiration: {
                parcelFromExpiration: {required, minValue: minValue(1)},
                newExpiration: {
                    dateRange: date => {
                        if (date && date.length === 10) {
                            return moment(date, "YYYY-MM-DD").isBetween('1901-01-01', '2200-12-31', null, '[]')
                        } else if (date && date.length > 10) {
                            return false
                        }
                        return true
                    }, required,
                },
            },

            readjustBatchValue: {
                parcelFrom: {required, minValue: minValue(1)},
                parcelTo: {required, minValue: minValue(1)},
                newValue: {required, minValue: minValue(0)},
            },

        },

        data() {
            return {
                optionsToast: { timeout: 6000, position: 'topCenter' },

                addParcelsModal: false,
                titleAddParcelsModal: '',
                okTextAddParcelsModal: '',

                changeParcelsModal: false,
                titleChangeParcelsModal_l1:'',
                titleChangeParcelsModal_l2:'',
                okTextChangeParcelsModal: '',

                batchChangeParcelsModal: false,
                titleBatchChangeParcelsModal_l1: '',
                titleBatchChangeParcelsModal_l2: '',
                okTextBatchChangeModal: '',

                patient: this.patientProp,

                orthodonticsParcels: {
                    parcel_number: 1,
                    expirationDateFirstParcel: '',
                    selectedFrequency: 'monthly',
                    monthlyPayment: 0,
                    patient_id: this.patientProp.id
                },

                readjustBatchValue: {
                    parcelFrom: 1,
                    parcelTo: 1,
                    newValue: 0,
                    patient_id: this.patientProp.id
                },

                readjustBatchExpiration: {
                    parcelFromExpiration: 1,
                    newExpiration: '',
                    patient_id: this.patientProp.id,
                    selectedFrequency: 'monthly'
                },

                columns:[
                    { width: '5%', label: '#', name: 'checkbox', type: 'Slot', sortable: true },
                    { width: '5%', label: 'CÓD.', name: 'id', type: 'String', sortable: true },
                    { width: '5%', label: 'PARCELA.', name: 'parcel', type: 'Number', sortable: true },
                    { width: '10%', label: 'VENCIMENTO', name: 'expiration_date', type: 'Date', sortable: true },
                    { width: '10%', label: 'VALOR', name: 'value', type: 'Currency', sortable: true },
                    { width: '10%', label: 'PAGO EM', name: 'payday', type: 'Date', sortable: true },
                    { width: '20%', label: 'SITUAÇÃO', name: 'situation', type: 'Change', change:{ PAID: 'PAGO', PENDING: 'EM ABERTO' }, sortable: true },
                    { width: '35', label: 'DESCRIÇÃO', name: 'observation', type: 'String', sortable: false },
                    // { width: '5%', label: 'AÇÃO', name: 'action', type: 'action', sortable: false },
                ],

                checkAll: false,
                checkedParcels: [],
                checkedParcelsChange: [],
            }
        },

        computed: {

        },

        watch: {
            checkAll: function (value, lastValue) {
                if(value) this.checkedParcels = this.$refs.dataTables.apiData;
                else this.checkedParcels = []
            },
        },

        methods: {
            async addOrthodonticsParcels() {
                if (this.$v.orthodonticsParcels.$invalid) {
                    this.$toast.warning('Por favor revise os campos obrigatórios do formulário', 'Aviso', this.optionsToast);
                    return false
                }

                try {
                    const response = await axios.post('/orthodontic', this.orthodonticsParcels)

                    if(response.data.type == 'success'){
                        this.addParcelsModal = false
                        this.$refs.dataTables.reload()
                        this.$toast.success(response.data.message, response.data.title, this.optionsToast);
                    } else if(response.data.type == 'warning'){
                        this.$toast.warning(response.data.message, response.data.title, this.optionsToast);
                    } else {
                        this.$toast.info(response.data.message, response.data.title, this.optionsToast);
                    }
                } catch (error) {
                    console.log(error);
                    if(error.response.status === 401 || error.response.status === 419){
                        this.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', this.optionsToast);
                    } else {
                        this.$toast.error(error.response.data.message, 'Erro', this.optionsToast);
                    }
                }
            },

            handleAddParcelsModal() {
                this.titleAddParcelsModal = 'Adicionar parcelas de tratamento ortodontico para ' + this.patient.name,
                this.okTextAddParcelsModal = 'Adicionar parcelas',
                this.addParcelsModal = true
            },

            handleChangeParcelsModal(){
                if(this.checkedParcels.length == 0){
                    this.$toast.warning('Selecione ao menos uma parcela para alterar.', 'AVISO', this.optionsToast);
                    return false
                }

                this.checkedParcelsChange = _.cloneDeep(this.checkedParcels);

                this.titleChangeParcelsModal_l1 = 'Alterar parcelas de tratamento ortodontico para',
                this.titleChangeParcelsModal_l2 = this.patient.name,
                this.okTextChangeParcelsModal = 'Alterar parcelas',
                this.changeParcelsModal = true
            },

            async changeOrthodonticsParcels() {
                if (this.$v.checkedParcelsChange.$invalid) {
                    this.$toast.warning('Por favor revise o formulário', 'Aviso', this.optionsToast);
                    return false
                }

                try {
                    const response = await axios.put('/orthodontic',this.checkedParcelsChange)

                    if(response.data.type == 'success'){
                        this.checkAll = false
                        this.changeParcelsModal = false
                        this.$refs.dataTables.reload()
                        this.$toast.success(response.data.message, response.data.title, this.optionsToast);
                    } else if(response.data.type == 'warning'){
                        this.$toast.warning(response.data.message, response.data.title, this.optionsToast);
                    } else {
                        this.$toast.info(response.data.message, response.data.title, this.optionsToast);
                    }
                } catch (error) {
                    console.log(error);
                    if(error.response.status === 401 || error.response.status === 419){
                        this.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', this.optionsToast);
                    } else {
                        this.$toast.error(error.response.data.message, 'Erro', this.optionsToast);
                    }
                }
            },

            handleReadjustBatchModal(){
                if(this.$refs.dataTables.apiData.length == 0){
                    this.$toast.warning('Não existem parcelas.', 'AVISO', this.optionsToast);
                    return false
                }

                this.batchChangeParcelsModal = true,
                this.titleBatchChangeParcelsModal_l1 = 'Alteração em lote de parcelas otodonticas de',
                this.titleBatchChangeParcelsModal_l2 = '',
                this.okTextBatchChangeModal = ''
            },

            async batchChangeExpirationDateOrthodonticsParcels(){
                if (this.$v.readjustBatchExpiration.$invalid) {
                    this.$toast.warning('Por favor revise o formulário', 'Aviso', this.optionsToast);
                    return false
                }

                try {
                    const response = await axios.put('/orthodontic/batchExpiration',this.readjustBatchExpiration)

                    if(response.data.type == 'success'){
                        this.batchChangeParcelsModal = false,
                        this.checkAll = false
                        this.$refs.dataTables.reload()
                        this.$toast.success(response.data.message, response.data.title, this.optionsToast);
                    } else if(response.data.type == 'warning'){
                        this.$toast.warning(response.data.message, response.data.title, this.optionsToast);
                    } else {
                        this.$toast.info(response.data.message, response.data.title, this.optionsToast);
                    }
                } catch (error) {
                    console.log(error);
                    if(error.response.status === 401 || error.response.status === 419){
                        this.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', this.optionsToast);
                    } else {
                        this.$toast.error(error.response.data.message, 'Erro', this.optionsToast);
                    }
                }
            },

            async batchChangeValueOrthodonticsParcels(){
                if (this.$v.readjustBatchValue.$invalid) {
                    this.$toast.warning('Por favor revise o formulário', 'Aviso', this.optionsToast);
                    return false
                }

                try {
                    const response = await axios.put('/orthodontic/batchValue',this.readjustBatchValue)

                    if(response.data.type == 'success'){
                        this.batchChangeParcelsModal = false,
                        this.checkAll = false

                        this.$refs.dataTables.reload()
                        this.$toast.success(response.data.message, response.data.title, this.optionsToast);
                    } else if(response.data.type == 'warning'){
                        this.$toast.warning(response.data.message, response.data.title, this.optionsToast);
                    } else {
                        this.$toast.info(response.data.message, response.data.title, this.optionsToast);
                    }
                } catch (error) {
                    console.log(error);
                    if(error.response.status === 401 || error.response.status === 419){
                        this.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', this.optionsToast);
                    } else {
                        this.$toast.error(error.response.data.message, 'Erro', this.optionsToast);
                    }
                }

            },

            resetAddParcelsModal() {
                this.orthodonticsParcels = {
                    parcel_number: 1,
                    expirationDateFirstParcel: '',
                    selectedFrequency: 'monthly',
                    monthlyPayment: 0,
                    patient_id: this.patientProp.id
                }
            },

            resetChangeParcelsModal(){
                this.checkedParcelsChange = []
            },

            resetBatchChangeParcelsModal(){
                this.readjustBatchValue = {
                    parcelFrom: 1,
                        parcelTo: 1,
                        newValue: 0,
                        patient_id: this.patientProp.id
                },

                this.readjustBatchExpiration = {
                    parcelFromExpiration: 1,
                        newExpiration: '',
                        patient_id: this.patientProp.id,
                        selectedFrequency: 'monthly'
                }
            }
        },
    }
</script>

<style scoped>

</style>